import { Raffle } from '@/app/entities/Raffle'
import Card from '@/view/components/Card'
import { Separator } from '@/view/components/ui/separator'
import { Link } from 'react-router-dom'
import RaffleSkeleton from './RaffleSkeleton'

interface LastRafflesProps {
  raffles: Raffle[] | undefined
  isLoading: boolean
}

const LastRaffles: React.FC<LastRafflesProps> = ({ raffles, isLoading }) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 2 }).map((_, index) => (
          <RaffleSkeleton key={index} />
        ))}
      </div>
    )
  }

  if (!raffles || raffles.length === 0) {
    return <p>Nenhum sorteio recente disponível.</p>
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {raffles.map((raffle) => {
        const firstWinner = raffle?.winners?.[0]
        return (
          <Link
            to={`/sorteios/${raffle._id}`}
            key={raffle?._id}
            className="h-fit"
          >
            <Card className="flex w-full flex-col gap-4 border bg-transparent p-4 sm:p-5">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
                <img
                  className="h-16 w-16 self-center rounded-lg object-cover sm:h-20 sm:w-20 sm:self-auto"
                  src={import.meta.env.VITE_CDN_URL + raffle?.banner}
                  alt="banner"
                />
                <h2 className="truncate text-center text-lg font-semibold sm:text-left sm:text-xl">
                  {raffle?.name}
                </h2>
              </div>
              <Separator />
              <div className="flex w-full flex-col gap-3 rounded-lg bg-gray-100 px-3 py-4 font-semibold sm:flex-row sm:items-center sm:justify-between sm:px-4 sm:py-5">
                <span className="text-center text-sm sm:text-left sm:text-base">
                  {firstWinner?.user?.name ?? 'N/A'}
                </span>
                <div className="self-center rounded-md bg-primary p-2 text-center text-white sm:p-[10px]">
                  {firstWinner?.code ?? 'N/A'}
                </div>
              </div>
            </Card>
          </Link>
        )
      })}
    </div>
  )
}

export default LastRaffles
